import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { ItemDetailContainer } from "./components/ItemDetailContainer/ItemDetailContainer";
import { ItemListContainer } from "./components/ItemListContainer/ItemListContainer";
import { NavBar } from "./components/NavBar/NavBar";
import { Cart } from "./components/Cart/Cart";
import { WishList } from "./components/WishList/WishList";
import { ChakraProvider } from "@chakra-ui/react";
import { CartContextProvider } from "./Context/CartContext";
import { useState } from "react";
import { Checkout } from "./components/Checkout/Checkout";
import { auth } from "./utils/config";
import Login from "./components/Login/Login";
import Register from "./components/Register/Register";
import OrderContainer from "./components/OrderContainer/OrderContainer";
import OrderDetail from "./components/OrderDetail/OrderDetail";
function App() {
  const [showNav, setShowNav] = useState(true);
  // Agregar estado de autenticación para controlar si el usuario está autenticado o no.

  // Maneja el cambio de estado de autenticación cuando el usuario cierra sesión

  return (
    <ChakraProvider>
      <CartContextProvider>
        <BrowserRouter>
          {/* {showNav && <NavBar />} */}
          <NavBar />
          <Routes>
            <Route path="/" element={<ItemListContainer greeting="Store" />} />
            <Route
              path="/category/:categoryId"
              element={<ItemListContainer greeting="Store" />}
            />
            <Route
              path="/detail/:productId"
              element={<ItemDetailContainer functionNav={setShowNav} />}
            />
            <Route path="/Cart" element={<Cart />} />
            <Route path="/WishList" element={<WishList />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="*" element={<h1>Error</h1>} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/misOrdenes" element={<OrderContainer />} />
            <Route path="/detalleOrden/:id" element={<OrderDetail />} />
          </Routes>
        </BrowserRouter>
      </CartContextProvider>
    </ChakraProvider>
  );
}

export default App;
